define('views/user/login/login',['backbone',
		'text!views/user/login/login.html',
		'views/_base/baseview',
		'views/user/register/register',
		'views/shared/emailverification/emailverification',
		'views/user/login/validatemachine',
		'models/validator/email'
], function (Backbone, Template, BaseView, RegisterView, EmailVerificationView, ValidateMachineView, EmailValidator) {
	'use strict';

	return BaseView.extend({
		isRender  : true,
		needsAuth : false,
		activityIndicator: true,
		tagName: 'section',
		className: 'loggedOut',
		id: 'login',
		template  : _.template(Template),
		events    : {
			'input 	.md-input'            	: 'handleMDInputLabel',
			'change .js-validate-on-change' : 'validateOnChange',
			'click 	#loginLogoIcon'  		: 'goToLandingView',
			'click 	a'               		: 'showMainHeader',
			'submit #loginForm'     		: 'login'
		},

		initialize: function (options) {
			options = options || {};

			this.goHome = options.goHome;
			this.callback = options.callback;
			this.callbackoptions = options.callbackoptions;
			this.cacheCallback = options.cacheCallback;
			this.elementName = options.elementName;
			this.IA = sessionStorage.getItem('InvAccount');
			this.referralCode = options && options.options && options.options.ReferralCode ? options.options.ReferralCode : null;
			this.site_version = pf.getContent('version.id');

			if(this.referralCode){
				store.setStoreItem(enums.modelsEnum.ReferralCode, { Data: this.referralCode });
			}

			// If it doesn't exist, then set it to an empty string
			if(!this.callbackCopy){
				this.callbackCopy = '';
			}

			this.hideMainHeader();
			// This is needed to handle Anthem/Partner site differences in UI/Styling
			handlePartnerDiffs();

			BaseView.prototype.initialize(this);
		},

		render: function () {
			this.$el.html(this.template({ site_version: this.site_version }));
			this.elEmailInput = this.$('#email-address');
			this.elEmailFeedback = getMDInputFeedbackEl(this.elEmailInput);
			this.elPasswordInput = this.$('#password');
			this.elPasswordFeedback = getMDInputFeedbackEl(this.elPasswordInput);
			this.elLoginBtn = $('#loginBtn');
			
			if (!Modernizr.touch) {
				this.elEmailInput.focus();
			}

			this.addPfMobileAdvantages();
			this.addMobileRatingStars();
			
			return this;
		},

		goToLandingView: function(){
			pf.navigate('');
			this.showMainHeader();
		},

		addMobileRatingStars: function() {
			var rating = Math.round(pf.getContent('login.content.marketing.rating'));

			for(var i = 0; i < rating; i++){
				var star = enums.svg.star;
				this.$('.js-downloadmobileapp-stars').append(star);
			};
		},

		addPfMobileAdvantages: function(){
			var that = this;
			
			if(this.site_version == enums.siteVersion.bcbsal){

				var copy = pf.getContent('login.content.marketing.copy');

				this.$('.js-downloadmobileapp-copy').parent().addClass(pf.getContent('version.name'));
				this.$('.js-downloadmobileapp-copy').html(copy);

			} else if(this.site_version == enums.siteVersion.rxsavings){

				var copy = pf.getContent('login.content.marketing.copy');

				this.$('.js-downloadmobileapp-copy').parent().addClass(pf.getContent('version.name'));
				this.$('.js-downloadmobileapp-copy').html(copy);

			} else if(this.site_version == enums.siteVersion.proteus){

				var copy = pf.getContent('login.content.marketing.copy');

				this.$('.js-downloadmobileapp-copy').parent().addClass(pf.getContent('version.name'));
				this.$('.js-downloadmobileapp-copy').html(copy);
			} else if (this.site_version == enums.siteVersion.alahealth) {

				var copy = pf.getContent('login.content.marketing.copy');

				this.$('.js-downloadmobileapp-copy').parent().addClass(pf.getContent('version.name'));
				this.$('.js-downloadmobileapp-copy').html(copy);

			} else if(this.site_version == enums.siteVersion.bcbssc){

				var copy = pf.getContent('login.content.marketing.copy');

				this.$('.js-downloadmobileapp-copy').parent().addClass(pf.getContent('version.name'));
				this.$('.js-downloadmobileapp-copy').html(copy);

			} else if(this.site_version == enums.siteVersion.csnp){

					var copy = pf.getContent('login.content.marketing.copy');
	
					this.$('.js-downloadmobileapp-copy').parent().addClass(pf.getContent('version.name'));
					this.$('.js-downloadmobileapp-copy').html(copy);

			} else if(this.site_version == enums.siteVersion.almyblue){

				var copy = pf.getContent('login.content.marketing.copy');

				this.$('.js-downloadmobileapp-copy').parent().addClass(pf.getContent('version.name'));
				this.$('.js-downloadmobileapp-copy').html(copy);

			} else {

				var html = '',
					incentives = pf.getContent('login.content.marketing.app_incentives');

				$.each(incentives, function() {
					html += '<li>' + this.copy + '</li>';                
				});

				$('.js-pfMobileAdvantages').html(html);

			}

			
		},

		showMainHeader: function() {
			$('#header-container').css('display','block');
		},

		hideMainHeader: function() {
			$('#header-container').css('display','none');
		},

		validateOnChange: function(e) {
			switch (e.target.id) {
				case 'email-address':
					this.validateEmail();
					break;
				case 'password':
					this.validatePassword();
			}
		},

		validateEmail: function() {
			var email = this.elEmailInput.val(),
				validator = new EmailValidator;
			validator.validate(email);
			if ( validator.isValid() ) {
				styleMDInputDefault(this.elEmailInput);
				removeMDFeedback(this.elEmailFeedback);
			} else {
				styleMDInputInvalid(this.elEmailInput);
				addMDFeedback(this.elEmailFeedback, pf.getContent('validation.email.invalid'));
			}
			return validator;
		},

		validatePassword: function() {
			var password = this.elPasswordInput.val();
			if (password.length < 1 || !password) {
				styleMDInputInvalid(this.elPasswordInput);
				addMDFeedback(this.elPasswordFeedback, pf.getContent('validation.password.empty'));
				return false;
			} else {
				styleMDInputDefault(this.elPasswordInput);
				removeMDFeedback(this.elPasswordFeedback);
				return true;
			}
		},
		
		login: function (e, callback) {
			if (e && e.preventDefault) { e.preventDefault(); }
			if (e && e.stopPropagation) { e.stopPropagation(); }

			var that = this,
				emailValidator = this.validateEmail(),
				passwordPresent = this.validatePassword();

			if (emailValidator.isValid() == false || passwordPresent == false) {
				return false;
			} else {
				if (this.callback != null) {
					// If we do not want to cache the callback and the callback has already been used, then set callback to false
					if(this.cacheCallback == false && this.callbackCopy.toString() == this.callback.toString()){
						this.callback = false;
					} else {
						this.callbackCopy = this.callback;
						callback = this.callback;
					}
				} else {
					this.callback = false;
				}

				this.elLoginBtn.addClass('btn-showSpinner').attr('disabled', true);
				
				var data = Backbone.Syphon.serialize(this);
				data.eMail = data.eMail.trim();
				store.getStoreItem(enums.modelsEnum.EmailVerificationPassed, null, false, false, false, function (data) {
					that.EmailVerificationPassed = data;
				});

				pf.session.login({
					E : data.eMail,
					P : data.Password,
					FP: $.fingerprint(),
					verifyonly: true,
					RC: this.referralCode
				}, function(resp){

					that.hideActivityIndicator();
					store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, { Data: that.EmailVerificationPassed });
					
					if(resp != null){

						that.showMainHeader();

						if(pf.session.get('auth')){
							
							that.elLoginBtn.removeClass('btn-showSpinner').attr('disabled', false);

							if(callback){
								callback(that.callbackoptions);
							}
							//only navigate home if value set to true, which should only be from login links
							if (that.IA) {
								sessionStorage.removeItem('InvAccount');
								// pf.navigate('causes/' + that.IA);

								// TODO: Go to relavant savings
								pf.navigate('home');

							} else if (that.goHome) {
								pf.navigate('home');
							} else {
								var path = pf.getCurrentRoute();
								if (!isEmpty(path) && path.toLowerCase().indexOf('login') < 0) {
									// pf.navigate(path);
									Backbone.history.loadUrl(path);
								} else {
									pf.navigate('home');
								}
							}

						} else {
							if (!pf.session.get('EmailVerified')) {
								var emailVerificationView = new EmailVerificationView({ resp: resp }).render();
									pf.show(new EmailVerificationView({ resp: resp }), '#mainRegion');
							}
								//else if ((!pf.session.get('MachineValidatedByUser') || !pf.session.get('RememberManchine')) && pf.IsConsumerFinancial && pf.session.get('SecurityQuestions').models.length > 0) {// ****** DONOT REMOVE ******
							//        new ValidateMachineView({resp: resp, elementName: '#mainRegion' });
							//} // ****** DONOT REMOVE ******
							else {
								pf.session.saveToken(resp);
								//pf.session.manageCognito(data.Password);

								if (callback) {
									callback(that.callbackoptions);
								}

								// only navigate home if value set to true, which should only be from login links
								if (that.IA) {
									sessionStorage.removeItem('InvAccount');
									pf.navigate('causes/' + that.IA);
								} else if (that.goHome) {
									pf.navigate('home');
								} else {
									var path = pf.getCurrentRoute();
									if (!isEmpty(path) && path.toLowerCase().indexOf('login') < 0) {
										// debugger;
										// pf.navigate(path, { trigger: false });
										Backbone.history.loadUrl(path);
									} else {
										pf.navigate('home');
									}
								}
							}
						}
					} else {
						that.elLoginBtn.removeClass('btn-showSpinner').attr('disabled', false);
					}
				});
			}                
		},

		handleMDInputLabel: function(e) {
			handleMDInputLabel( $(e.target) );
		},

		close: function () {
			var that = this;
			pf.globalEvents.off('goToInvitationAccount');
			this.cleanupEvents();
		}
	});
});

